import { render, staticRenderFns } from "./InvoiceAdd.vue?vue&type=template&id=0fffc58c&scoped=true&"
import script from "./InvoiceAdd.vue?vue&type=script&lang=js&"
export * from "./InvoiceAdd.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InvoiceAdd.vue?vue&type=style&index=1&id=0fffc58c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fffc58c",
  null
  
)

export default component.exports